export default class LocalStorage {
    
    static getAllStorage = () => {
        var archive = {},
            keys = Object.keys(localStorage),
            i = keys.length;

        while (i--) {
            archive[keys[i]] = localStorage.getItem(keys[i]);
        }

        return archive;
    }

    static setStudentData = (name, schoolName, grade, id, score) => {
        localStorage.setItem("name", name);
        localStorage.setItem("schoolName", schoolName);
        localStorage.setItem("grade", grade);
        localStorage.setItem("id", id)

        if (score || score === 0) {
            localStorage.setItem("score", score);
        }
    }

    static getItem = (itemWanted) => {
        return localStorage.getItem(itemWanted);
    }

    static setItem = (itemWanted, val) => {
        return localStorage.setItem(itemWanted, val);
    }

    static getIsMuted = () => {
        return JSON.parse(localStorage.getItem("isMuted"));
    }
}